import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { XIcon } from "../../../images/icons/icons";

const BenefitsForm = ({
  isEdit,
  rowData,
  closeModal,
  userInfoData,
  callFunction,
  categoryOptions,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const initialFormValues = {
    name: isEdit && rowData?.name ? rowData.name : "",
    category_id: isEdit && rowData?.category_id ? rowData.category_id : "",
    isActive: isEdit && rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [selectedCategory, setSelectedCategory] = useState(
    isEdit && rowData?.category_id
      ? categoryOptions?.find((opt) => opt.value === rowData.category_id) || null
      : null
  );
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeCategory = (selected) => {
    setSelectedCategory(selected);
    setFormValues((prev) => ({
      ...prev,
      category_id: selected?.value || "",
    }));
  };

  const validateForm = (values) => {
    const errors = {};
    if (!values.name?.trim()) {
      errors.name = "Name is required";
    }
    if (!values.category_id) {
      errors.category_id = "Category is required";
    }
    return errors;
  };

  const handleSubmitForm = async (userData) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit
      ? "/addoncat/benefits/update"
      : "/addoncat/benefits/add";
    const token = userInfoData?.token || "";

    const requestBody = userData;

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
        toast.success(
          result?.payload?.message || "Benefit saved successfully!"
        );
        callFunction();
        closeModal();
      } else {
        const errorMessage =
          result?.error?.message ||
          result?.payload?.message ||
          "Failed to save benefit!";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error making POST request:", error);
      toast.error("Something went wrong!");
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const userData = {
        name: formValues.name || "",
        category_id: formValues.category_id || "",
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  return (
    <div className="addon-cat-form-modal">
      <div className="addon-cat-header">
        <h2 className="addon-cat-title">
          {isEdit ? "Edit Benefit" : "Add Benefits"}
        </h2>
        <button className="addon-cat-close-btn" onClick={closeModal}>
          <XIcon />
        </button>
      </div>

      <form className="addon-cat-form" onSubmit={onSubmit}>
        <div className="addon-cat-form-group">
          <label className="addon-cat-label">
            Category <span className="addon-cat-required">*</span>
          </label>
          <Select
            value={selectedCategory}
            onChange={onChangeCategory}
            options={categoryOptions || []}
            placeholder="Category"
            className={`addon-cat-select ${formErrors.category_id ? "error" : ""}`}
            classNamePrefix="react-select"
            isClearable
          />
          {formErrors.category_id && (
            <span className="addon-cat-error">{formErrors.category_id}</span>
          )}
        </div>

        <div className="addon-cat-form-group">
          <label className="addon-cat-label">
            Name <span className="addon-cat-required">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formValues.name}
            onChange={onChangeInput}
            placeholder="Name"
            className={`addon-cat-input ${formErrors.name ? "error" : ""}`}
          />
          {formErrors.name && (
            <span className="addon-cat-error">{formErrors.name}</span>
          )}
        </div>

        <div className="addon-cat-form-group addon-cat-toggle-group">
          <label className="addon-cat-toggle">
            <input
              type="checkbox"
              name="isActive"
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
            <span className="addon-cat-toggle-slider"></span>
          </label>
          <span className="addon-cat-toggle-label">
            {formValues.isActive ? "Active" : "Inactive"}
          </span>
        </div>

        <div className="addon-cat-form-actions">
          <button
            type="button"
            className="addon-cat-btn addon-cat-btn-secondary"
            onClick={closeModal}
            disabled={postPutLoading}
          >
            Close
          </button>
          <button
            type="submit"
            className="addon-cat-btn addon-cat-btn-primary"
            disabled={postPutLoading}
          >
            {postPutLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default BenefitsForm;
